import * as types from '@/store/mutation-types.js'
import api from 'modules/member/api'

const state = {
  memberIsLogin: false, // 是否在会员中心页面 true -- 是， false -- 否
  expressCompany: {
    'SF': '顺丰',
    'HTKY': '百世快递',
    'ZTO': '中通',
    'STO': '申通',
    'YTO': '圆通',
    'YD': '韵达',
    'YZPY': '邮政平邮',
    'EMS': 'EMS',
    'HHTT': '天天',
    'JD': '京东',
    'QFKD': '全峰',
    'GTO': '国通',
    'UC': '优速',
    'DBL': '德邦',
    'FAST': '快捷',
    'AMAZON': '亚马逊',
    'ZJS': '宅急送'
  },
  memberInfo: {}, // 用户信息
  storeInfo: {} // 店铺信息
}
const getters = {}
const actions = {
  async fetchAccountProfile ({ commit }) {
    return new Promise(async (resolve, reject) => {
      const response = await api.fetchAccountProfile()
      commit(types.MEMBER_INFORMATION, response)
      resolve(true)
    })
  }
}

const mutations = {
  [types.MEMBER_SHOW_LOGIN] (state) {
    state.memberIsLogin = false
    window.location.href = 'index.html'
  },
  [types.MEMBER_IS_LOGIN] (state) {
    state.memberIsLogin = true
  },
  [types.MEMBER_INFORMATION] (state, memberInfo) {
    state.memberInfo = memberInfo
  },
  [types.MEMBER_STORE_MANAGE_STORE_INFO] (state, storeInfo) {
    state.storeInfo = storeInfo
  },
  [types.MEMBER_CLEAR_INFO] (state) {
    state.memberInfo = {}
    state.storeInfo = {}
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/member/index.js